import { useFormContext } from 'react-hook-form';
import { ChargeReasonSelector } from 'src/modals/SaleDetails/components/PaymentSection/SaleLineItemModal/ChargeOrCreditReason/ChargeReasonSelector';
import { CreditReasonSelector } from 'src/modals/SaleDetails/components/PaymentSection/SaleLineItemModal/ChargeOrCreditReason/CreditReasonSelector';
import { SaleCostType, SaleLineItem } from 'src/WebApiController';

export const ChargeOrCreditReasonSelector = () => {
  const { watch } = useFormContext<SaleLineItem>();
  const costType = watch('costType');
  const isChargeType = costType === SaleCostType.Charge;
  const isCreditType = costType === SaleCostType.Credit;

  if (isChargeType) {
    return <ChargeReasonSelector />;
  }

  if (isCreditType) {
    return <CreditReasonSelector />;
  }

  return null;
};
